module.exports = __webpack_public_path__ + "static/img/account_icon3.c5f67630.png";